import { portalText } from "../../i18n/portal.js";
/**
 * How Numbers & SIP writes a number and a SIP response — the design's shapes, from wire values.
 *
 * `+14155550142` is stored and sent in E.164 because that is what every carrier takes; a person
 * reads `+1 415 555 0142`. Only the North American plan is grouped (its shape is fixed at
 * 3-3-4); any other number is shown as stored rather than grouped by a guess.
 */

/** Moved to `@wetalk/view-model/party-mask` (plan-034 VIEW-PKG); re-exported here so no portal importer changes. */
export { displayNumberOf } from "@wetalk/view-model/party-mask";

/** The reason phrases RFC 3261 gives the responses a trunk trace shows most often. */
const REASON: Readonly<Record<number, string>> = {
  get 100() { return portalText("operations", "trying_773fd0d1"); },
  get 180() { return portalText("operations", "ringing_81b62ad7"); },
  get 183() { return portalText("operations", "session_progress_e382c457"); },
  200: "OK",
  get 401() { return portalText("operations", "unauthorized_740b8315"); },
  get 403() { return portalText("operations", "forbidden_3dab5f60"); },
  get 404() { return portalText("operations", "not_found_d205cbd6"); },
  get 407() { return portalText("operations", "proxy_authentication_required_9e3fc12e"); },
  get 408() { return portalText("operations", "request_timeout_dca0c381"); },
  get 480() { return portalText("operations", "temporarily_unavailable_e9dc866e"); },
  get 486() { return portalText("operations", "busy_here_7b6903f1"); },
  get 487() { return portalText("operations", "request_terminated_251fd0e3"); },
  get 488() { return portalText("operations", "not_acceptable_here_759bc992"); },
  get 500() { return portalText("operations", "server_internal_error_b979ca6d"); },
  get 503() { return portalText("operations", "service_unavailable_ffbd0b77"); },
  get 603() { return portalText("operations", "decline_b59cf9ed"); },
};

/** `200 OK`; a code without a phrase here is shown as the bare code; no response is `—`. */
export function sipResponseOf(code: number | null): string {
  if (code === null) return "—";
  const phrase = REASON[code];
  return phrase === undefined ? String(code) : `${String(code)} ${phrase}`;
}
